import { Box, Modal, Button, Grid, Typography } from '@mui/material';
import ModalStyle from 'src/components/modal/ModalStyle';

/**
 * A modal component to display a message
 *
 * @param {Object} props
 * @param {string} props.message - The message to be displayed in the modal
 * @param {boolean} props.open - Whether the modal should be open or closed
 * @param {function} props.handleClose - A function to handle the closing of the modal
 *
 * @returns {JSX.Element} A modal component
 */
const MessageModal = ({ message, open, handleClose }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={ModalStyle}>
        <Typography variant="h6">{message}</Typography>
        <Grid container spacing={2} sx={{ justifyContent: 'end' }}>
          <Grid item>
            <Button variant="contained" data-cy="close" onClick={handleClose}>
              Close
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default MessageModal;
